// CD: backend
let loading;
if (!customElements.get('pushe-card-quick')) customElements.define('pushe-card-quick', class extends HTMLElement {
connectedCallback() { this.hidden = false; }
});
function open(detail) {
loading ??= import('./pushe-cart-drawer.js');
loading.then(m => m.openCartDrawer(detail)).catch(() => {
loading = null;
window.location.assign(`${document.querySelector('[data-cart-drawer]')?.dataset.cartRoot || '/'}cart`);
});
}
document.addEventListener('click', e => {
const card = e.target.closest('pushe-card-quick');
if (card) {
e.preventDefault();
import('./pushe-quick-add-loader.js').then(m => m.handle(card, e.target)).catch(() =>
window.location.assign(card.closest('.pushe-card').querySelector('.pushe-card__name').href));
return;
}
const opener = e.target.closest('.pushe-header__cart');
if (!opener || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
e.preventDefault();
open({ opener, keyboard: e.detail === 0 });
});
document.addEventListener('pushe:cart:added', e => open(e.detail));
